import { Typography } from '@mui/material';

import { Breadcrumb } from './types';

interface Props {
  breadcrumb: Breadcrumb;
  isActive?: boolean;
}

const BreadcrumbLabel = ({ breadcrumb, isActive }: Props) => {
  return (
    <Typography
      variant="small"
      sx={(theme) => ({
        color: isActive
          ? theme.vars.palette.primary.main
          : theme.vars.palette.text.secondary,
        transition: theme.transitions.create(['color']),
        '&:hover': {
          color: theme.vars.palette.primary.main,
        },
        position: 'relative',
        top: theme.direction === 'ltr' ? 2 : 0,
      })}
    >
      {breadcrumb.label}
    </Typography>
  );
};

export default BreadcrumbLabel;
